import * as types from "./mutation-types";

export default {
  [types.SET_CLIENTES](state, payload) {
    state.clientes = payload;
  },
  [types.SET_CLIENTE](state, payload) {
    state.cliente = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },

  [types.SET_CLIENTE_USERS](state, payload) {
    state.cliente_users = payload;
  },
  [types.SET_PAGINATION_USERS](state, payload) {
    state.pagination_users = payload;
  },

  [types.SET_CLIENTE_PAGAMENTOS](state, payload) {
    state.cliente_pagamentos = payload;
  },
  [types.SET_CLIENTE_ASSINATURA](state, payload) {
    if (!Array.isArray(state.cliente.clientePlanos)) return;

    state.cliente.clientePlanos.push(payload);
  },
  [types.UPDATE_CLIENTE_ASSINATURA](state, payload) {
    if (!Array.isArray(state.cliente.clientePlanos)) return;

    const { index, data } = payload;

    state.cliente.clientePlanos.splice(index, 1, data);
  },
  [types.REMOVE_CLIENTE_ASSINATURA](state, index) {
    if (!Array.isArray(state.cliente.clientePlanos)) return;

    state.cliente.clientePlanos.splice(index, 1);
  },
  [types.SET_PAGINATION_PAGAMENTOS](state, payload) {
    state.pagination_pagamentos = payload;
  },
  [types.SET_ERROR](state, payload) {
    state.error = payload;
  },
};
